import React, { useState } from 'react';
import Button from 'components/ui/Button';
import Icon from 'components/AppIcon';

const BulkActionsBar = ({ selectedCount, onBulkAction }) => {
  const [loadingAction, setLoadingAction] = useState('');

  const handleAction = async (action) => {
    if (loadingAction) return;
    if (window.confirm(`Are you sure you want to ${action.toLowerCase()} ${selectedCount} selected products?`)) {
      try {
        setLoadingAction(action);
        await onBulkAction(action);
      } finally {
        setLoadingAction('');
      }
    }
  };

  return (
    <div className="bg-primary-50 border border-primary-200 rounded-lg p-4 mb-6">
      <div className="flex items-center overflow-x-auto justify-between">
        <div className="flex items-center space-x-3">
          <Icon name="CheckCircle" size={20} color="#1e3a5f" />
          <span className="text-sm font-medium text-primary">
            {selectedCount} product{selectedCount !== 1 ? 's' : ''} selected
          </span>
        </div>
        
        <div className="flex items-center space-x-2">
          {/* <Button
            variant="outline"
            size="sm"
            iconName="Edit"
            onClick={() => handleAction('UPDATE_PRICE')}
            className="w-48"
          >
            Update Price
          </Button> */}
          
          {/* <Button
            variant="outline"
            size="sm"
            iconName="Package"
            onClick={() => handleAction('UPDATE_STOCK')}
          >
            Update Stock
          </Button> */}
          
          {/* <Button
            variant="outline"
            size="sm"
            iconName="QrCode"
            onClick={() => handleAction('GENERATE_QR')}
          >
            Generate QR Codes
          </Button> */}
          
          {/* <Button
            variant="outline"
            size="sm"
            iconName="Tag"
            onClick={() => handleAction('UPDATE_CATEGORY')}
          >
            Change Category
          </Button> */}
          
          {/* <Button
            variant="outline"
            size="sm"
            iconName="Download"
            onClick={() => handleAction('EXPORT')}
          >
            Export Selected
          </Button> */}
          
          <Button
            variant="danger"
            size="sm"
            iconName="Trash2"
            loading={loadingAction === 'DELETE'}
            onClick={() => handleAction('DELETE')}
          >
            Delete
          </Button>
        </div>
      </div>
    </div>
  );
};

export default BulkActionsBar;
